<template>
  <div class="">

    <Head />

    <div class="main reservation">
      <AccesskeyLink target="accesskey_c" accesskey="c" :aria-label="$t('跳到中央內容區塊')">
        :::
      </AccesskeyLink>

      <!-- 毛毛蟲 -->
      <nav aria-label="breadcrumb" class="breadcrumb_box">
        <div class="container">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><router-link to="/" :title="$t('首頁')">{{ $t('首頁') }}</router-link></li>
            <li class="breadcrumb-item active" aria-current="page">{{ $t('志工申請') }}</li>
          </ol>
        </div>
      </nav>

      <div class="reservation_box">
        <div class="container">

          <div class="title_box">
            <h2>{{ $t('志工申請表') }}</h2>
          </div>

          <div class="form_box">

            <!-- 基本資訊 -->
            <div class="section_title">
              <h3>{{ $t('基本資訊') }}</h3>
            </div>

            <!-- 1. 電子信箱 -->
            <div class="group">
              <label for="email" class="form-label">{{ $t('電子信箱') }}<span class="required">{{ $t('（必填）') }}</span></label>
              <input type="email" class="form-control" id="email" :placeholder="$t('請輸入電子信箱')" v-model="formData.email">
              <p v-if="errors.email" class="text-danger">{{ errors.email }}</p>
            </div>

            <!-- 2. 姓名 -->
            <div class="group">
              <label for="name" class="form-label">{{ $t('姓名') }}<span class="required">{{ $t('（必填）') }}</span></label>
              <input type="text" class="form-control" id="name" :placeholder="$t('請輸入姓名')" v-model="formData.name">
              <p v-if="errors.name" class="text-danger">{{ errors.name }}</p>
            </div>

            <!-- 個人資訊 -->
            <div class="section_title">
              <h3>{{ $t('個人資訊') }}</h3>
            </div>

            <!-- 3. 出生年月日 -->            <div class="group">
              <label for="birthDate" class="form-label">{{ $t('出生年月日') }}<span class="required">{{ $t('（必填）') }}</span></label>
              <input type="date" class="form-control" id="birthDate" v-model="formData.birthDate">
              <p v-if="errors.birthDate" class="text-danger">{{ errors.birthDate }}</p>
            </div>

            <!-- 4. 性別 -->
            <div class="group">
              <label for="gender" class="form-label">{{ $t('性別') }}<span class="required">{{ $t('（必填）') }}</span></label>
              <div class="check_box">
                <div class="form-check" v-for="item in genderItems" :key="item.value">
                  <input class="form-check-input" type="radio" name="gender" :id="`gender_${item.value}`" 
                    :value="item.value" v-model="formData.gender">
                  <label class="form-check-label" :for="`gender_${item.value}`">{{ item.title }}</label>
                </div>
              </div>
              <p v-if="errors.gender" class="text-danger">{{ errors.gender }}</p>
            </div>

            <!-- 5. 身份證字號 -->
            <div class="group">
              <label for="idCard" class="form-label">{{ $t('身份證字號') }}<span class="required">{{ $t('（必填）') }}</span></label>
              <input type="text" class="form-control" id="idCard" :placeholder="$t('請輸入身份證字號')" 
                v-model="formData.idCard" maxlength="10">
              <p v-if="errors.idCard" class="text-danger">{{ errors.idCard }}</p>
            </div>

            <!-- 5-1. 照片 -->
            <div class="group">
              <label for="photo" class="form-label">{{ $t('照片') }}<span class="required">{{ $t('（必填）') }}</span></label>
              <div class="file-upload">
                <input type="file" id="photo" accept=".jpg,.jpeg,.png" @change="handlePhotoChange" 
                  ref="photoInput" style="display: none;">
                <button type="button" class="send_btn" @click="$refs.photoInput.click()">{{ $t('選擇照片') }}</button>
                <!-- <button type="button" class="send_btn" @click="removePhoto" v-if="selectedPhoto">{{ $t('移除照片') }}</button> -->
                <div v-if="selectedPhoto" class="file-info">
                  <p>{{ $t('已選擇：') }}{{ selectedPhoto.name }}</p>
                  <img v-if="photoPreview" :src="photoPreview" :alt="$t('照片預覽')" class="photo-preview">                  
                </div>
              </div>
              <p class="notes mt-2">{{ $t('支援格式: JPG, PNG / 檔案大小上限: 5MB') }}</p>
              <p v-if="errors.photo" class="text-danger">{{ errors.photo }}</p>
            </div>

            <!-- 6. 學校 -->
            <div class="group">
              <label for="educationSchool" class="form-label">{{ $t('學校') }}<span class="required">{{ $t('（必填）') }}</span></label>
              <input type="text" class="form-control" id="educationSchool" :placeholder="$t('請輸入學校名稱')" 
                v-model="formData.educationSchool">
              <p v-if="errors.educationSchool" class="text-danger">{{ errors.educationSchool }}</p>
            </div>

            <!-- 7. 系所 -->
            <div class="group">
              <label for="educationDepartment" class="form-label">{{ $t('系所') }}<span class="required">{{ $t('（必填）') }}</span></label>
              <input type="text" class="form-control" id="educationDepartment" :placeholder="$t('請輸入系所名稱')" 
                v-model="formData.educationDepartment">
              <p v-if="errors.educationDepartment" class="text-danger">{{ errors.educationDepartment }}</p>
            </div>

            <!-- 8. 肄業/畢業 -->
            <div class="group">
              <label for="educationStatus" class="form-label">{{ $t('肄業/畢業') }}<span class="required">{{ $t('（必填）') }}</span></label>
              <select class="form-select" id="educationStatus" v-model="formData.educationStatus">
                <option value="">{{ $t('請選擇') }}</option>
                <option value="肄業">{{ $t('肄業') }}</option>
                <option value="畢業">{{ $t('畢業') }}</option>
              </select>
              <p v-if="errors.educationStatus" class="text-danger">{{ errors.educationStatus }}</p>
            </div>

            <!-- 9. 婚姻狀況 -->
            <div class="group">
              <label for="maritalStatus" class="form-label">{{ $t('婚姻狀況') }}<span class="required">{{ $t('（必填）') }}</span></label>
              <select class="form-select" id="maritalStatus" v-model="formData.maritalStatus">
                <option value="">{{ $t('請選擇') }}</option>
                <option value="已婚">{{ $t('已婚') }}</option>
                <option value="未婚">{{ $t('未婚') }}</option>
                <option value="其他">{{ $t('其他') }}</option>
              </select>
              <p v-if="errors.maritalStatus" class="text-danger">{{ errors.maritalStatus }}</p>
            </div>

            <!-- 10. 戶籍地址 -->
            <div class="group">
              <label for="residenceAddress" class="form-label">{{ $t('戶籍地址') }}<span class="required">{{ $t('（必填）') }}</span></label>
              <input type="text" class="form-control" id="residenceAddress" :placeholder="$t('請輸入戶籍地址')" 
                v-model="formData.residenceAddress">
              <p v-if="errors.residenceAddress" class="text-danger">{{ errors.residenceAddress }}</p>
            </div>

            <!-- 11. 通訊地址 -->
            <div class="group">
              <label for="mailingAddress" class="form-label">{{ $t('通訊地址') }}<span class="required">{{ $t('（必填）') }}</span></label>
              <div class="form-check mb-2">
                <input class="form-check-input" type="checkbox" id="copyAddress" v-model="copyResidenceToMailing">
                <label class="form-check-label" for="copyAddress">{{ $t('同戶籍地址') }}</label>
              </div>
              <input type="text" class="form-control" id="mailingAddress" :placeholder="$t('請輸入通訊地址')" 
                v-model="formData.mailingAddress" :readonly="copyResidenceToMailing">
              <p v-if="errors.mailingAddress" class="text-danger">{{ errors.mailingAddress }}</p>
            </div>

            <!-- 聯絡方式 -->
            <div class="section_title">
              <h3>{{ $t('聯絡方式') }}</h3>
            </div>

            <!-- 12. 住家電話 -->
            <div class="group">
              <label for="phoneHome" class="form-label">{{ $t('住家電話') }}</label>
              <input type="text" class="form-control" id="phoneHome" :placeholder="$t('請輸入住家電話')" 
                v-model="formData.phoneHome">
              <p v-if="errors.phoneHome" class="text-danger">{{ errors.phoneHome }}</p>
            </div>

            <!-- 13. 辦公電話 -->
            <div class="group">
              <label for="phoneOffice" class="form-label">{{ $t('辦公電話') }}</label>
              <input type="text" class="form-control" id="phoneOffice" :placeholder="$t('請輸入辦公電話')" 
                v-model="formData.phoneOffice">
              <p v-if="errors.phoneOffice" class="text-danger">{{ errors.phoneOffice }}</p>
            </div>

            <!-- 14. 手機 -->
            <div class="group">
              <label for="phoneMobile" class="form-label">{{ $t('手機') }}</label>
              <input type="text" class="form-control" id="phoneMobile" :placeholder="$t('請輸入手機號碼')" 
                v-model="formData.phoneMobile">
              <p v-if="errors.phoneMobile" class="text-danger">{{ errors.phoneMobile }}</p>
              <p class="notes">{{ $t('※ 住家電話、辦公電話、手機三者至少需填寫一個') }}</p>
            </div>

            <!-- 就業/就學狀況 -->
            <div class="section_title">
              <h3>{{ $t('就業/就學狀況') }}</h3>
            </div>

            <!-- 15. 就業/就學狀態 -->
            <div class="group">
              <label for="employmentStatus" class="form-label">{{ $t('就業/就學狀態') }}<span class="required">{{ $t('（必填）') }}</span></label>
              <select class="form-select" id="employmentStatus" v-model="formData.employmentStatus">
                <option value="">{{ $t('請選擇') }}</option>
                <option value="就業中">{{ $t('就業中') }}</option>
                <option value="就學中">{{ $t('就學中') }}</option>
                <option value="退休">{{ $t('退休') }}</option>
                <option value="其他">{{ $t('其他') }}</option>
              </select>
              <p v-if="errors.employmentStatus" class="text-danger">{{ errors.employmentStatus }}</p>
            </div>

            <!-- 16. 就業單位 (條件顯示) -->
            <div class="group" v-if="formData.employmentStatus === '就業中'">
              <label for="employmentOrganization" class="form-label">{{ $t('就業單位') }}<span class="required">{{ $t('（必填）') }}</span></label>
              <input type="text" class="form-control" id="employmentOrganization" :placeholder="$t('請輸入就業單位')" 
                v-model="formData.employmentOrganization">
              <p v-if="errors.employmentOrganization" class="text-danger">{{ errors.employmentOrganization }}</p>
            </div>

            <!-- 17. 就讀學校 (條件顯示) -->
            <div class="group" v-if="formData.employmentStatus === '就學中'">
              <label for="currentSchool" class="form-label">{{ $t('就讀學校') }}<span class="required">{{ $t('（必填）') }}</span></label>
              <input type="text" class="form-control" id="currentSchool" :placeholder="$t('請輸入就讀學校')" 
                v-model="formData.currentSchool">
              <p v-if="errors.currentSchool" class="text-danger">{{ errors.currentSchool }}</p>
            </div>

            <!-- 18. 其他狀態說明 (條件顯示) -->
            <div class="group" v-if="formData.employmentStatus === '其他'">
              <label for="employmentStatusOther" class="form-label">{{ $t('其他狀態說明') }}<span class="required">{{ $t('（必填）') }}</span></label>
              <input type="text" class="form-control" id="employmentStatusOther" :placeholder="$t('請說明其他狀態')" 
                v-model="formData.employmentStatusOther">
              <p v-if="errors.employmentStatusOther" class="text-danger">{{ errors.employmentStatusOther }}</p>
            </div>

            <!-- 志工經驗 -->
            <div class="section_title">
              <h3>{{ $t('志工經驗') }}</h3>
            </div>

            <!-- 19. 過去志工經驗 -->
            <div class="group">
              <label for="volunteerExperiencePast" class="form-label">{{ $t('過去志工經驗') }}</label>
              <textarea class="form-control" id="volunteerExperiencePast" rows="3" 
                :placeholder="$t('請描述過去的志工經驗')" v-model="formData.volunteerExperiencePast"></textarea>
              <p v-if="errors.volunteerExperiencePast" class="text-danger">{{ errors.volunteerExperiencePast }}</p>
            </div>

            <!-- 20. 目前志工經驗 -->
            <div class="group">
              <label for="volunteerExperienceCurrent" class="form-label">{{ $t('目前志工經驗') }}</label>
              <textarea class="form-control" id="volunteerExperienceCurrent" rows="3" 
                :placeholder="$t('請描述目前的志工經驗')" v-model="formData.volunteerExperienceCurrent"></textarea>
              <p v-if="errors.volunteerExperienceCurrent" class="text-danger">{{ errors.volunteerExperienceCurrent }}</p>
            </div>

            <!-- 21. 志願服務手冊 -->
            <div class="group">
              <label for="hasServiceBook" class="form-label">{{ $t('志願服務手冊') }}<span class="required">{{ $t('（必填）') }}</span></label>
              <div class="check_box">
                <div class="form-check" v-for="item in serviceBookItems" :key="item.value">
                  <input class="form-check-input" type="radio" name="hasServiceBook" 
                    :id="`hasServiceBook_${item.value}`" :value="item.value" v-model="formData.hasServiceBook">
                  <label class="form-check-label" :for="`hasServiceBook_${item.value}`">{{ item.title }}</label>
                </div>
              </div>
              <p v-if="errors.hasServiceBook" class="text-danger">{{ errors.hasServiceBook }}</p>
            </div>

            <!-- 專長與興趣 -->
            <div class="section_title">
              <h3>{{ $t('專長與興趣') }}</h3>
            </div>

            <!-- 22-23. 專長 -->
            <div class="group">
              <label class="form-label">{{ $t('專長') }}</label>
              <div class="check_box">
                <div class="form-check" v-for="(specialty, index) in specialtiesList" :key="index">
                  <input class="form-check-input" type="checkbox" :value="specialty" 
                    v-model="formData.specialties" :id="`specialty_${index}`">
                  <label class="form-check-label" :for="`specialty_${index}`">{{ specialty }}</label>
                </div>
              </div>
              <div class="mt-3" v-if="formData.specialties.includes('其他')">
                <input type="text" class="form-control" :placeholder="$t('請說明其他專長')" 
                  v-model="formData.specialtiesOther">
                <p v-if="errors.specialtiesOther" class="text-danger">{{ errors.specialtiesOther }}</p>
              </div>
            </div>

            <!-- 24. 興趣 -->
            <div class="group">
              <label for="interests" class="form-label">{{ $t('興趣') }}</label>
              <textarea class="form-control" id="interests" rows="3" 
                :placeholder="$t('請描述您的興趣')" v-model="formData.interests"></textarea>
              <p v-if="errors.interests" class="text-danger">{{ errors.interests }}</p>
            </div>

            <!-- 語言能力 -->
            <div class="section_title">
              <h3>{{ $t('語言能力') }}</h3>
            </div>

            <!-- 25. 華語 -->
            <div class="group">
              <label for="languageMandarin" class="form-label">{{ $t('華語') }}<span class="required">{{ $t('（必填）') }}</span></label>
              <select class="form-select" id="languageMandarin" v-model="formData.languageMandarin">
                <option value="">{{ $t('請選擇') }}</option>
                <option value="精通">{{ $t('精通') }}</option>
                <option value="中等">{{ $t('中等') }}</option>
                <option value="略懂">{{ $t('略懂') }}</option>
                <option value="不會">{{ $t('不會') }}</option>
              </select>
              <p v-if="errors.languageMandarin" class="text-danger">{{ errors.languageMandarin }}</p>
            </div>

            <!-- 26. 英語 -->
            <div class="group">
              <label for="languageEnglish" class="form-label">{{ $t('英語') }}<span class="required">{{ $t('（必填）') }}</span></label>
              <select class="form-select" id="languageEnglish" v-model="formData.languageEnglish">
                <option value="">{{ $t('請選擇') }}</option>
                <option value="精通">{{ $t('精通') }}</option>
                <option value="中等">{{ $t('中等') }}</option>
                <option value="略懂">{{ $t('略懂') }}</option>
                <option value="不會">{{ $t('不會') }}</option>
              </select>
              <p v-if="errors.languageEnglish" class="text-danger">{{ errors.languageEnglish }}</p>
            </div>

            <!-- 27. 臺語 -->
            <div class="group">
              <label for="languageTaiwanese" class="form-label">{{ $t('臺語') }}<span class="required">{{ $t('（必填）') }}</span></label>
              <select class="form-select" id="languageTaiwanese" v-model="formData.languageTaiwanese">
                <option value="">{{ $t('請選擇') }}</option>
                <option value="精通">{{ $t('精通') }}</option>
                <option value="中等">{{ $t('中等') }}</option>
                <option value="略懂">{{ $t('略懂') }}</option>
                <option value="不會">{{ $t('不會') }}</option>
              </select>
              <p v-if="errors.languageTaiwanese" class="text-danger">{{ errors.languageTaiwanese }}</p>
            </div>

            <!-- 28. 日語 -->
            <div class="group">
              <label for="languageJapanese" class="form-label">{{ $t('日語') }}<span class="required">{{ $t('（必填）') }}</span></label>
              <select class="form-select" id="languageJapanese" v-model="formData.languageJapanese">
                <option value="">{{ $t('請選擇') }}</option>
                <option value="精通">{{ $t('精通') }}</option>
                <option value="中等">{{ $t('中等') }}</option>
                <option value="略懂">{{ $t('略懂') }}</option>
                <option value="不會">{{ $t('不會') }}</option>
              </select>
              <p v-if="errors.languageJapanese" class="text-danger">{{ errors.languageJapanese }}</p>
            </div>

            <!-- 29-30. 其他語言 -->
            <div class="group">
              <label class="form-label">{{ $t('其他語言') }}</label>
              <div class="form-check mb-2">
                <input class="form-check-input" type="checkbox" id="hasOtherLanguage" 
                  v-model="formData.hasOtherLanguage">
                <label class="form-check-label" for="hasOtherLanguage">{{ $t('有其他語言能力') }}</label>
              </div>
              <div v-if="formData.hasOtherLanguage" class="row">
                <div class="col-md-6 mb-3">
                  <input type="text" class="form-control" :placeholder="$t('語言名稱')" 
                    v-model="formData.otherLanguageName">
                  <p v-if="errors.otherLanguageName" class="text-danger">{{ errors.otherLanguageName }}</p>
                </div>
                <div class="col-md-6 mb-3">
                  <select class="form-select" v-model="formData.otherLanguageLevel">
                    <option value="">{{ $t('請選擇程度') }}</option>
                    <option value="精通">{{ $t('精通') }}</option>
                    <option value="中等">{{ $t('中等') }}</option>
                    <option value="略懂">{{ $t('略懂') }}</option>
                  </select>
                  <p v-if="errors.otherLanguageLevel" class="text-danger">{{ errors.otherLanguageLevel }}</p>
                </div>
              </div>
            </div>

            <!-- 申請動機 -->
            <div class="section_title">
              <h3>{{ $t('申請動機') }}</h3>
            </div>

            <!-- 31-32. 動機 -->
            <div class="group">
              <label class="form-label">{{ $t('申請動機') }}</label>
              <div class="check_box">
                <div class="form-check" v-for="(motivation, index) in motivationsList" :key="index">
                  <input class="form-check-input" type="checkbox" :value="motivation" 
                    v-model="formData.motivations" :id="`motivation_${index}`">
                  <label class="form-check-label" :for="`motivation_${index}`">{{ motivation }}</label>
                </div>
              </div>
              <div class="mt-3" v-if="formData.motivations.includes('其他')">
                <input type="text" class="form-control" :placeholder="$t('請說明其他動機')" 
                  v-model="formData.motivationsOther">
                <p v-if="errors.motivationsOther" class="text-danger">{{ errors.motivationsOther }}</p>
              </div>
            </div>

            <!-- 健康狀況 -->
            <div class="section_title">
              <h3>{{ $t('健康狀況') }}</h3>
            </div>

            <!-- 33-34. 特殊疾病 -->
            <div class="group">
              <label for="hasSpecialDisease" class="form-label">{{ $t('特殊疾病') }}<span class="required">{{ $t('（必填）') }}</span></label>
              <select class="form-select" id="hasSpecialDisease" v-model="formData.hasSpecialDisease">
                <option value="">{{ $t('請選擇') }}</option>
                <option value="有">{{ $t('有') }}</option>
                <option value="無">{{ $t('無') }}</option>
              </select>
              <p v-if="errors.hasSpecialDisease" class="text-danger">{{ errors.hasSpecialDisease }}</p>
              <div class="mt-3" v-if="formData.hasSpecialDisease === '有'">
                <textarea class="form-control" rows="3" :placeholder="$t('請說明疾病狀況')" 
                  v-model="formData.specialDiseaseDescription"></textarea>
                <p v-if="errors.specialDiseaseDescription" class="text-danger">{{ errors.specialDiseaseDescription }}</p>
              </div>
            </div>

            <!-- 可服勤時段 -->
            <div class="section_title">
              <h3>{{ $t('可服勤時段') }}</h3>
            </div>

            <!-- 35-36. 可服勤時段 -->
            <div class="group">
              <label class="form-label">{{ $t('可服勤時段') }}<span class="required">{{ $t('（必填）') }}</span></label>
              <div class="table-responsive">
                <table class="table table-bordered">
                  <thead>
                    <tr>
                      <th>{{ $t('星期/時間') }}</th>
                      <th v-for="day in weekDays" :key="day">{{ day }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="slot in timeSlots" :key="slot">
                      <td>{{ slot }}</td>
                      <td v-for="day in weekDays" :key="day">
                        <div v-if="day !== '星期三'">
                          <input class="form-check-input" type="checkbox" 
                            :value="`${day}-${slot}`" v-model="formData.availableSchedule">
                          <span v-if="getScheduleOrder(`${day}-${slot}`)" class="badge bg-primary ms-2">
                            {{ getScheduleOrder(`${day}-${slot}`) }}
                          </span>
                        </div>
                        <div v-else class="text-muted">{{ $t('休館日') }}</div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p class="notes">{{ $t('請依照優先順序勾選可服勤時段，系統會自動標注順序號碼') }}</p>
              <p v-if="errors.availableSchedule" class="text-danger">{{ errors.availableSchedule }}</p>
            </div>

            <!-- 其他資訊 -->
            <div class="section_title">
              <h3>{{ $t('其他資訊') }}</h3>
            </div>

            <!-- 37. 自我介紹 -->
            <div class="group">
              <label for="selfIntroduction" class="form-label">{{ $t('自我介紹') }}<span class="required">{{ $t('（必填）') }}</span></label>
              <textarea class="form-control" id="selfIntroduction" rows="5" 
                :placeholder="$t('請簡單介紹您自己')" v-model="formData.selfIntroduction"></textarea>
              <p v-if="errors.selfIntroduction" class="text-danger">{{ errors.selfIntroduction }}</p>
            </div>

            <!-- 同意條款 -->
            <div class="group requirement_box">
              <div class="check_box">
                <div class="form-check">
                  <input class="form-check-input" type="checkbox" id="agree" v-model="agree">
                  <label class="form-check-label" for="agree">
                    {{ $t('我已經詳細閱讀個人資料使用同意書並同意相關規範') }}
                  </label>
                </div>
              </div>
              <a href="/data/個人資料使用同意書.pdf" target="_blank" class="send_btn" style="display: inline-block; margin-top: 10px; text-decoration: none;">
                {{ $t('下載個人資料使用同意書') }}
              </a>
              <p v-if="errors.agree" class="text-danger">{{ errors.agree }}</p>
            </div>

            <!-- 送出按鈕 -->
            <div class="btn_box">
              <button type="button" class="send_btn" @click="gotoPage('/')">{{ $t('返回首頁') }}</button>
              <button type="button" class="send_btn" @click="submitForm" :disabled="isSubmitting">
                {{ isSubmitting ? $t('送出中...') : $t('確認送出') }}
              </button>
            </div>

          </div>

        </div>
      </div>

    </div>

    <Footer />

  </div>
</template>

<script>
import Head from '@/components/Head.vue'
import Footer from '@/components/Footer.vue'
import AccesskeyLink from '@/views/AccesskeyLink.vue'

export default {
  name: 'VolunteerApplicationForm',
  components: {
    Head,
    Footer,
    AccesskeyLink,
  },

  data() {
    return {
      // 性別選項
      genderItems: [],

      // 志願服務手冊選項
      serviceBookItems: [],

      // 專長列表
      specialtiesList: [
        '導覽解說', '藝術文學', '歷史人文', '水電木工', '動物生態',
        '植物生態', '電腦美工', '攝影繪圖', '電腦文書', '護理急救', '其他'
      ],

      // 動機列表
      motivationsList: [
        '回饋社會，服務他人', '吸收藝文新知', '精神生活樂趣', '交新朋友',
        '打發空閒時間', '磨練自己', '其他'
      ],

      // 星期
      weekDays: ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'],

      // 時段
      timeSlots: ['09時-12時', '13時-16時'],

      // 表單資料
      formData: {
        email: '',
        name: '',
        birthDate: '',
        gender: '',
        idCard: '',
        educationSchool: '',
        educationDepartment: '',
        educationStatus: '',
        maritalStatus: '',
        residenceAddress: '',
        mailingAddress: '',
        isSameAsResidence: false,
        phoneHome: '',
        phoneOffice: '',
        phoneMobile: '',
        employmentStatus: '',
        employmentOrganization: '',
        currentSchool: '',
        employmentStatusOther: '',
        volunteerExperiencePast: '',
        volunteerExperienceCurrent: '',
        hasServiceBook: '',
        specialties: [],
        specialtiesOther: '',
        interests: '',
        languageMandarin: '',
        languageEnglish: '',
        languageTaiwanese: '',
        languageJapanese: '',
        hasOtherLanguage: false,
        otherLanguageName: '',
        otherLanguageLevel: '',
        motivations: [],
        motivationsOther: '',
        hasSpecialDisease: '',
        specialDiseaseDescription: '',
        availableSchedule: [],
        selfIntroduction: '',
      },

      // 複製戶籍地址到通訊地址
      copyResidenceToMailing: false,

      // 檔案相關
      selectedPhoto: null,
      photoPreview: null,

      // 同意條款
      agree: false,

      // 表單驗證錯誤
      errors: {},

      // 送出中狀態
      isSubmitting: false,
    }
  },

  watch: {
    // 監聽戶籍地址變化，自動複製到通訊地址
    'formData.residenceAddress'(newVal) {
      if (this.copyResidenceToMailing) {
        this.formData.mailingAddress = newVal
      }
    },
    // 監聽複選框變化
    copyResidenceToMailing(newVal) {
      if (newVal) {
        this.formData.mailingAddress = this.formData.residenceAddress
      }
    },
  },

  mounted() {
    // 初始化翻譯選項
    this.genderItems = [
      { value: '男', title: this.$t('男') },
      { value: '女', title: this.$t('女') },
      { value: '其他', title: this.$t('其他') }
    ]
    
    this.serviceBookItems = [
      { value: '有', title: this.$t('有') },
      { value: '無', title: this.$t('無') }
    ]
    
    this.specialtiesList = [
      this.$t('導覽解說'), this.$t('藝術文學'), this.$t('歷史人文'), 
      this.$t('水電木工'), this.$t('動物生態'), this.$t('植物生態'),
      this.$t('電腦美工'), this.$t('攝影繪圖'), this.$t('電腦文書'),
      this.$t('護理急救'), this.$t('其他')
    ]
    
    this.motivationsList = [
      this.$t('回饋社會，服務他人'), this.$t('吸收藝文新知'),
      this.$t('精神生活樂趣'), this.$t('交新朋友'),
      this.$t('打發空閒時間'), this.$t('磨練自己'),
      this.$t('其他')
    ]
    
    // 翻譯星期和時段
    this.weekDays = [
      this.$t('星期一'), this.$t('星期二'), this.$t('星期三'), 
      this.$t('星期四'), this.$t('星期五'), this.$t('星期六'), this.$t('星期日')
    ]
    
    this.timeSlots = [
      this.$t('09時-12時'), this.$t('13時-16時')
    ]
  },

  methods: {
    // 處理照片選擇
    handlePhotoChange(event) {
      const file = event.target.files[0]
      if (!file) return

      // 檢查檔案大小 (5MB)
      if (file.size > 5 * 1024 * 1024) {
        alert(this.$t('照片檔案大小不得超過 5MB'))
        event.target.value = ''
        return
      }

      // 檢查檔案類型
      const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif']
      if (!allowedTypes.includes(file.type)) {
        alert(this.$t('請選擇有效的圖片檔案 (JPG, PNG, GIF)'))
        event.target.value = ''
        return
      }

      this.selectedPhoto = file

      // 產生預覽並轉換為 Base64
      const reader = new FileReader()
      reader.onload = (e) => {
        this.photoPreview = e.target.result
        // 儲存 Base64 資料供後續上傳使用
        this.formData.photoBase64 = e.target.result
        this.formData.photoFileName = file.name
      }
      reader.readAsDataURL(file)
    },

    // 移除照片
    removePhoto() {
      this.selectedPhoto = null
      this.photoPreview = null
      if (this.$refs.photoInput) {
        this.$refs.photoInput.value = ''
      }
    },

    // 取得時段排序
    getScheduleOrder(slot) {
      const index = this.formData.availableSchedule.indexOf(slot)
      return index >= 0 ? index + 1 : null
    },

    // 台灣身分證字號驗證
    validateTaiwanId(value) {
      if (!value) return false
      
      const pattern = /^[A-Z][12]\d{8}$/
      if (!pattern.test(value)) return false
      
      // 字母轉數字對照表
      const letterMap = {
        A: 10, B: 11, C: 12, D: 13, E: 14, F: 15, G: 16, H: 17, I: 34, J: 18,
        K: 19, L: 20, M: 21, N: 22, O: 35, P: 23, Q: 24, R: 25, S: 26, T: 27,
        U: 28, V: 29, W: 32, X: 30, Y: 31, Z: 33
      }
      
      const firstLetter = value.charAt(0)
      const num = letterMap[firstLetter]
      
      // 計算檢查碼
      let sum = Math.floor(num / 10) + (num % 10) * 9
      for (let i = 1; i < 9; i++) {
        sum += parseInt(value.charAt(i)) * (9 - i)
      }
      sum += parseInt(value.charAt(9))
      
      return sum % 10 === 0
    },

    // 表單驗證
    validateForm() {
      this.errors = {}

      // 基本資訊
      if (!this.formData.email) {
        this.errors.email = this.$t('請輸入電子信箱')
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.formData.email)) {
        this.errors.email = this.$t('請輸入有效的電子信箱')
      }

      if (!this.formData.name) {
        this.errors.name = this.$t('請輸入姓名')
      }

      // 個人資訊
      if (!this.formData.birthDate) {
        this.errors.birthDate = this.$t('請選擇出生年月日')
      }

      if (!this.formData.gender) {
        this.errors.gender = this.$t('請選擇性別')
      }

      if (!this.formData.idCard) {
        this.errors.idCard = this.$t('請輸入身份證字號')
      } else if (!this.validateTaiwanId(this.formData.idCard)) {
        this.errors.idCard = this.$t('請輸入有效的台灣身分證字號')
      }

      // 照片必填
      if (!this.selectedPhoto) {
        this.errors.photo = this.$t('請上傳照片')
      }

      if (!this.formData.educationSchool) {
        this.errors.educationSchool = this.$t('請輸入學校')
      }

      if (!this.formData.educationDepartment) {
        this.errors.educationDepartment = this.$t('請輸入系所')
      }

      if (!this.formData.educationStatus) {
        this.errors.educationStatus = this.$t('請選擇肄業/畢業')
      }

      if (!this.formData.maritalStatus) {
        this.errors.maritalStatus = this.$t('請選擇婚姻狀況')
      }

      if (!this.formData.residenceAddress) {
        this.errors.residenceAddress = this.$t('請輸入戶籍地址')
      }

      if (!this.formData.mailingAddress) {
        this.errors.mailingAddress = this.$t('請輸入通訊地址')
      }

      // 聯絡方式 - 三個電話至少填一個
      if (!this.formData.phoneHome && !this.formData.phoneOffice && !this.formData.phoneMobile) {
        this.errors.phoneMobile = this.$t('住家電話、辦公電話、手機三者至少需填寫一個')
      } else if (this.formData.phoneMobile && !/^09\d{8}$/.test(this.formData.phoneMobile)) {
        this.errors.phoneMobile = this.$t('請輸入有效的手機號碼（格式：09XXXXXXXX）')
      }

      // 就業/就學狀況
      if (!this.formData.employmentStatus) {
        this.errors.employmentStatus = this.$t('請選擇就業/就學狀態')
      }

      if (this.formData.employmentStatus === '就業中' && !this.formData.employmentOrganization) {
        this.errors.employmentOrganization = this.$t('請輸入就業單位')
      }

      if (this.formData.employmentStatus === '就學中' && !this.formData.currentSchool) {
        this.errors.currentSchool = this.$t('請輸入就讀學校')
      }

      if (this.formData.employmentStatus === '其他' && !this.formData.employmentStatusOther) {
        this.errors.employmentStatusOther = this.$t('請說明其他狀態')
      }

      // 志工經驗
      if (!this.formData.hasServiceBook) {
        this.errors.hasServiceBook = this.$t('請選擇是否有志願服務手冊')
      }

      // 專長
      if (this.formData.specialties.includes('其他') && !this.formData.specialtiesOther) {
        this.errors.specialtiesOther = this.$t('請說明其他專長')
      }

      // 語言能力
      if (!this.formData.languageMandarin) {
        this.errors.languageMandarin = this.$t('請選擇華語能力')
      }

      if (!this.formData.languageEnglish) {
        this.errors.languageEnglish = this.$t('請選擇英語能力')
      }

      if (!this.formData.languageTaiwanese) {
        this.errors.languageTaiwanese = this.$t('請選擇臺語能力')
      }

      if (!this.formData.languageJapanese) {
        this.errors.languageJapanese = this.$t('請選擇日語能力')
      }

      if (this.formData.hasOtherLanguage) {
        if (!this.formData.otherLanguageName) {
          this.errors.otherLanguageName = this.$t('請輸入語言名稱')
        }
        if (!this.formData.otherLanguageLevel) {
          this.errors.otherLanguageLevel = this.$t('請選擇語言程度')
        }
      }

      // 動機
      if (this.formData.motivations.includes('其他') && !this.formData.motivationsOther) {
        this.errors.motivationsOther = this.$t('請說明其他動機')
      }

      // 健康狀況
      if (!this.formData.hasSpecialDisease) {
        this.errors.hasSpecialDisease = this.$t('請選擇是否有特殊疾病')
      }

      if (this.formData.hasSpecialDisease === '有' && !this.formData.specialDiseaseDescription) {
        this.errors.specialDiseaseDescription = this.$t('請說明疾病狀況')
      }

      // 可服勤時段
      if (this.formData.availableSchedule.length === 0) {
        this.errors.availableSchedule = this.$t('請至少選擇一個可服勤時段')
      }

      // 自我介紹
      if (!this.formData.selfIntroduction) {
        this.errors.selfIntroduction = this.$t('請填寫自我介紹')
      }

      // 同意條款
      if (!this.agree) {
        this.errors.agree = this.$t('請閱讀並同意相關規範後再送出')
      }

      return Object.keys(this.errors).length === 0
    },

    // 送出表單
    async submitForm() {
      if (!this.validateForm()) {
        const firstError = Object.keys(this.errors)[0]
        const errorElement = document.getElementById(firstError)
        if (errorElement) {
          errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' })
        }
        return
      }

      if (this.isSubmitting) return
      this.isSubmitting = true

      try {
        // 準備提交資料 - 將欄位名稱轉換為 PascalCase (首字母大寫)
        const submitData = {
          // 基本資訊
          Email: this.formData.email,
          Name: this.formData.name,
          
          // 個人資訊
          BirthDate: this.formData.birthDate,
          Gender: this.formData.gender,
          IdCard: this.formData.idCard,
          PhotoBase64: this.formData.photoBase64,
          PhotoFileName: this.formData.photoFileName,
          EducationSchool: this.formData.educationSchool,
          EducationDepartment: this.formData.educationDepartment,
          EducationStatus: this.formData.educationStatus,
          MaritalStatus: this.formData.maritalStatus,
          ResidenceAddress: this.formData.residenceAddress,
          MailingAddress: this.formData.mailingAddress,
          IsSameAsResidence: this.copyResidenceToMailing,
          
          // 聯絡方式
          PhoneHome: this.formData.phoneHome || null,
          PhoneOffice: this.formData.phoneOffice || null,
          PhoneMobile: this.formData.phoneMobile || null,
          
          // 就業/就學狀況
          EmploymentStatus: this.formData.employmentStatus,
          EmploymentOrganization: this.formData.employmentOrganization || null,
          CurrentSchool: this.formData.currentSchool || null,
          EmploymentStatusOther: this.formData.employmentStatusOther || null,
          
          // 志工經驗
          VolunteerExperiencePast: this.formData.volunteerExperiencePast || null,
          VolunteerExperienceCurrent: this.formData.volunteerExperienceCurrent || null,
          HasServiceBook: this.formData.hasServiceBook,
          
          // 專長與興趣 - 轉換為 JSON 字串格式（與後端一致）
          Specialties: this.formData.specialties.length > 0 ? JSON.stringify(this.formData.specialties) : null,
          SpecialtiesOther: this.formData.specialtiesOther || null,
          Interests: this.formData.interests || null,
          
          // 語言能力
          LanguageMandarin: this.formData.languageMandarin,
          LanguageEnglish: this.formData.languageEnglish,
          LanguageTaiwanese: this.formData.languageTaiwanese,
          LanguageJapanese: this.formData.languageJapanese,
          HasOtherLanguage: this.formData.hasOtherLanguage,
          OtherLanguageName: this.formData.otherLanguageName || null,
          OtherLanguageLevel: this.formData.otherLanguageLevel || null,
          
          // 申請動機 - 轉換為 JSON 字串格式（與後端一致）
          Motivations: this.formData.motivations.length > 0 ? JSON.stringify(this.formData.motivations) : null,
          MotivationsOther: this.formData.motivationsOther || null,
          
          // 健康狀況
          HasSpecialDisease: this.formData.hasSpecialDisease,
          SpecialDiseaseDescription: this.formData.specialDiseaseDescription || null,
          
          // 可服勤時段 - 轉換為 JSON 字串格式（與後端一致）
          AvailableSchedule: this.formData.availableSchedule.length > 0 ? JSON.stringify(this.formData.availableSchedule) : null,
          
          // 其他資訊
          SelfIntroduction: this.formData.selfIntroduction,
        }

        const apiUrl = `${this.$store.state.src}${this.$store.state.subDirectory}/ChachaStaffVolunteer/Public/ApplyVolunteer`
        
        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(submitData),
        })

        const data = await response.json()

        if (data.ok) {
          alert(data.message || this.$t('申請成功！我們將於審核後與您聯繫'))
         this.$router.push('/')
        } else {
          alert(data.message || this.$t('申請失敗，請稍後再試'))
        }
      } catch (error) {
        console.error('提交失敗:', error)
        alert(this.$t('提交時發生錯誤，請稍後再試'))
      } finally {
        this.isSubmitting = false
      }
    },

    gotoPage(path) {
      if (this.$route.path !== path) {
        this.$router.push(path)
      }
    },
  },
}
</script>

<style scoped>
/* 修正核取方塊和單選按鈕的固定尺寸 */
.form-check-input[type="checkbox"],
.form-check-input[type="radio"] {
  width: 1.25rem;
  height: 1.25rem;
  min-width: 1.25rem;
  min-height: 1.25rem;
  flex-shrink: 0;
}

.section_title {
  margin-top: 30px;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #000;
}

.section_title h3 {
  font-size: 1.5rem;
  font-weight: bold;
  color: #000;
  margin: 0;
}

.file-upload {
  margin-top: 10px;
}

.file-info {
  margin-top: 15px;
  padding: 15px;
  background-color: #f8f9fa;
  border-radius: 5px;
}

.file-info p {
  margin-bottom: 10px;
  font-weight: bold;
}

.photo-preview {
  max-width: 300px;
  max-height: 300px;
  object-fit: cover;
  border: 1px solid #ddd;
  border-radius: 5px;
  margin-bottom: 10px;
}

.table th, .table td {
  text-align: center;
  vertical-align: middle;
}

.badge {
  display: inline-block;
  padding: 0.25em 0.5em;
  font-size: 0.75rem;
  font-weight: 700;
  line-height: 1;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
}

.bg-primary {
  background-color: #007bff !important;
}

.alert {
  padding: 1rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: 0.25rem;
}

.alert-info {
  color: #0c5460;
  background-color: #d1ecf1;
  border-color: #bee5eb;
}

.alert-link {
  color: #062c33;
  font-weight: bold;
  text-decoration: underline;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.ms-2 {
  margin-left: 0.5rem !important;
}

.mt-3 {
  margin-top: 1rem !important;
}

.mb-2 {
  margin-bottom: 0.5rem !important;
}

.mb-3 {
  margin-bottom: 1rem !important;
}

.col-md-6 {
  flex: 0 0 auto;
  width: 50%;
}

@media (max-width: 768px) {
  .col-md-6 {
    width: 100%;
  }
}
</style>
